


























import { AuthenticationStore } from '@store/modules/data/authentication/authenticationIndex';
import { SdsButton } from '@superbet-group/web.lib.ui-components';
import {
    useVueRouter,
    useVuexStore,
} from '@superbet-group/web.lib.vue-utilities';
import {
    computed,
    defineComponent,
} from '@vue/composition-api';
import modalStore from '@store/modules/ui/shared/modal/modalIndex';
import modalCodes from '@store/modules/ui/shared/modal/modalCodes';
import { RouteName } from '@src/app/router/constants/RouteName';
import { useMobileHeaderData } from '@src/app/mobile/navbar/composables/useMobileHeaderData';
import { getShellConfig } from '@src/config/shell/config';
import { isAffiliateLanding } from '@core/services/marketing/_private/constants';

export default defineComponent({
    name: 'StickyLoginRegisterButtons',
    setup() {
        const {
            route,
            router,
        } = useVueRouter();

        const modalModule = useVuexStore<typeof modalStore>('ui/modal');
        const setModal = modalModule.action('setModal');
        function openLoginModal() {
            setModal({ code: modalCodes.login });
        }

        function goToRegisterRoute() {
            router.value.push({
                name: RouteName.Account.Register,
            });
        }

        const { isTopLevelRoute } = useMobileHeaderData();

        const authenticationModule = useVuexStore <AuthenticationStore>('data/authentication');
        const user = authenticationModule.getter('user');

        const isHubPage = computed(() => {
            return getShellConfig().remoteConfig.areSitesSplitByLicence
                && route.value.name === RouteName.GrowthMarketing.LandingIntro;
        });

        const showStickyLoginRegisterButtons = computed(() => {
            if (user.value) {
                return false;
            }

            return (isAffiliateLanding() && route.value.name !== RouteName.Account.Register)
                // Napoleon Hub should not have auth buttons because we
                // do not know the correct site in this context and cannot
                // authenticate the customer.
                || (isTopLevelRoute.value && !isHubPage.value);
        });

        return {
            showStickyLoginRegisterButtons,

            openLoginModal,
            goToRegisterRoute,
        };
    },
    components: {
        SdsButton,
    },
});
